import React from 'react';
import AboutMe from './AboutMeParagraph';

const Home: React.FC = (): JSX.Element => {
  return (
    <>
      <AboutMe />
  
    </>
  );
};

export default Home;